<template>
  <el-container v-title data-title="学生考勤统计" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
                <el-breadcrumb-item>实时刷卡率统计</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="schoolName" label="学校" width="150"></el-table-column>
          <el-table-column prop="cardHolderCount" label="总持卡人数" width="120"></el-table-column>
          <el-table-column prop="tempCount" label="已刷卡人数" width="120"></el-table-column>
          <el-table-column prop="readRate" label="刷卡率" width="120"></el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      loading: false,
      tableData: []
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getReadRate()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    getReadRate (row, group) {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/attendence/statsForReadRate').then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.tableData = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StatsForReadRate.vue